module.exports = __webpack_public_path__ + "img/zhubiao@2x_2.d292b142.png";